import { createSlice } from "@reduxjs/toolkit";
import { fetchEarningsListReducer } from "../../reducer/earnings/fetchEarningsListReducer";

const initialState = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const earningsListSlice = createSlice({
  name: "earningsList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEarningsListReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEarningsListReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.earnings || [];
        state.pagination = action.payload?.pagination || initialState.pagination;
      })
      .addCase(fetchEarningsListReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load earnings list.";
      });
  },
});

export default earningsListSlice.reducer;
